export default "__VITE_ASSET__Pb6dHxqh__"